import { application } from "./application"

import PositionMappingController from "./position_mapping_controller"
application.register("position-mapping", PositionMappingController)

import TurboFilterController from "./turbo_filter_controller"
application.register("turbo-filter", TurboFilterController)

import ChatSubscriptionController from "./chat_subscription_controller"
application.register("chat-subscription", ChatSubscriptionController)

import ChatListSidebarController from "./chat-list-sidebar"
application.register("chat-list-sidebar", ChatListSidebarController)

import AudioRecorderController from "./audio_recorder_controller"
application.register("audio-recorder", AudioRecorderController)

import CoachTrackingController from "./coach_tracking_controller"
application.register("coach-tracking", CoachTrackingController)